import { notifications } from 'src/utils/notifications';

export const showErrors = (errors: []) => {
  errors.forEach(
    ({ message, details }: { message: string; details: string }) => {
      notifications.error({ message: `${message}: ${details}` });
    }
  );
};
